export const trackedChangesKeys = {
  prefix: 'trackedChanges',
  list: (layerId: string, { password }: { password?: string | null }) => [
    trackedChangesKeys.prefix,
    layerId,
    'list',
    { password },
  ],
  toggleReaction: (trackedChangeId: string) => [trackedChangesKeys.prefix, trackedChangeId, 'toggleReaction'],
}
